import { render } from "./MainCard.vue?vue&type=template&id=6c83af6a&ts=true"
import script from "./MainCard.vue?vue&type=script&lang=ts"
export * from "./MainCard.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/descript/vue-js-teq-application/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__